import type { ReactNode } from 'react';

import { Overline } from '@/components/atoms/Eyebrow';

import styles from './DetailsSection.module.scss';

interface DetailsSectionProps {
    title: string;
    children: ReactNode;
}

/**
 * A named part of the dialog, so a screen reader can jump between Who, Target and the
 * rest. Its heading is one level below the modal's h5 title. Named by label rather than
 * by the heading's id: React's ids hold colons, which jsdom's selector engine cannot
 * resolve when the tests look a region up by name.
 */
export default function DetailsSection({ title, children }: DetailsSectionProps) {
    return (
        <section className={styles.section} aria-label={title}>
            <Overline as="h6" className={styles.heading}>
                {title}
            </Overline>
            {children}
        </section>
    );
}
